module.exports = __webpack_public_path__ + "static/img/gz-img01.05d64b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gz-img01.png
// module id = WWbM
// module chunks = 1